var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui two column stackable grid" },
    [
      _c("div", { staticClass: "ui dimmer" }, [
        _c("div", { staticClass: "content" }, [
          _c(
            "div",
            { staticClass: "ui icon header", staticStyle: { color: "red" } },
            [
              _c("i", { staticClass: "cancel icon" }),
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(
                    _vm.$t("globals.validation.errors.something_went_wrong")
                  ) +
                  "\n\t\t\t\t"
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sixteen wide column" }, [
        _c(
          "form",
          {
            staticClass: "ui form",
            class: { loading: _vm.showLoader },
            attrs: { "data-vv-scope": "userFieldForm" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.submitForm.apply(null, arguments)
              }
            }
          },
          [
            _c("div", { staticClass: "two fields" }, [
              _c("div", { staticClass: "field" }, [
                _c(
                  "label",
                  {
                    attrs: {
                      for: _vm.$t("pages.profile.settings.profile.form.email")
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("pages.profile.settings.profile.form.email")
                      ) + ":"
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "ui action input" }, [
                  _c("input", {
                    attrs: { type: "text", disabled: "" },
                    domProps: { value: _vm.fetchedUser.email }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "ui button",
                      on: {
                        click: function($event) {
                          _vm.showChangeEmailModal = !_vm.showChangeEmailModal
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("globals.buttons.change")))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c(
                  "label",
                  {
                    attrs: {
                      for: _vm.$t(
                        "pages.profile.settings.profile.form.password"
                      )
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("pages.profile.settings.profile.form.password")
                      )
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "ui action input" }, [
                  _c("input", {
                    attrs: { type: "text", disabled: "" },
                    domProps: {
                      value: _vm.$t(
                        "pages.profile.settings.profile.form.change_password"
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "ui button",
                      on: {
                        click: function($event) {
                          _vm.showChangePasswordModal = !_vm.showChangePasswordModal
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("globals.buttons.change")))]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "two fields" }, [
              _c(
                "div",
                {
                  staticClass: "field",
                  class: { error: _vm.errors.has("userFieldForm.firstname") }
                },
                [
                  _c("label", { attrs: { for: "firstname" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("pages.profile.settings.profile.form.first_name")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui corner labeled input" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.firstnameLocal,
                          expression: "firstnameLocal"
                        }
                      ],
                      attrs: {
                        type: "text",
                        name: "firstname",
                        disabled: !!_vm.fetchedUser.firstname
                      },
                      domProps: { value: _vm.firstnameLocal },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.firstnameLocal = $event.target.value
                        }
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "field",
                  class: { error: _vm.errors.has("userFieldForm.surname") }
                },
                [
                  _c("label", { attrs: { for: "lastname" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("pages.profile.settings.profile.form.last_name")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui corner labeled input" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.surnameLocal,
                          expression: "surnameLocal"
                        }
                      ],
                      attrs: {
                        type: "text",
                        name: "surname",
                        disabled: !!_vm.fetchedUser.surname
                      },
                      domProps: { value: _vm.surnameLocal },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.surnameLocal = $event.target.value
                        }
                      }
                    })
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _vm._l(_vm.chunkProperty(_vm.userFields, 2), function(
              userField,
              index
            ) {
              return _c(
                "div",
                { key: index, staticClass: "two fields" },
                _vm._l(userField, function(field) {
                  return field
                    ? _c("field", {
                        key: field.id,
                        attrs: {
                          field: field,
                          scope: "userFieldForm",
                          allowEdit: field.editable,
                          value: _vm.fieldValues,
                          transparent: false
                        },
                        on: { input: _vm.changeFieldValue }
                      })
                    : _vm._e()
                }),
                1
              )
            }),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "ui blue button", attrs: { type: "submit" } },
              [
                _c("i", { staticClass: "checkmark icon" }),
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.$t("globals.buttons.save_changes")) +
                    "\n\t\t\t\t"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ui red button", on: { click: _vm.cancelForm } },
              [
                _c("i", { staticClass: "cancel icon" }),
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.$t("globals.buttons.cancel")) +
                    "\n\t\t\t\t"
                )
              ]
            )
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm.activeMerchant.opus
        ? _c("div", { staticClass: "sixteen wide column" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "ui form",
                class: { loading: _vm.showLoaderSecond },
                attrs: { "data-vv-scope": "userSocialNumberForm" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.saveUserSocialNumber.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "field required",
                    class: {
                      error: _vm.errors.has(
                        "userSocialNumberForm.social_number"
                      )
                    }
                  },
                  [
                    _c("label", { attrs: { for: "social_number" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "pages.profile.settings.profile.form.social_number"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ui corner labeled input" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.forms.userSocialNumber,
                            expression: "forms.userSocialNumber"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|numeric",
                            expression: "'required|numeric'"
                          }
                        ],
                        attrs: {
                          type: "text",
                          name: "social_number",
                          "data-vv-as": _vm.$t(
                            "pages.profile.settings.profile.form.social_number"
                          )
                        },
                        domProps: { value: _vm.forms.userSocialNumber },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.forms,
                              "userSocialNumber",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(1)
                    ]),
                    _vm._v(" "),
                    _vm.errors.has("userSocialNumberForm.social_number")
                      ? _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.errors.first(
                                "userSocialNumberForm.social_number"
                              )
                            )
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "ui blue button", attrs: { type: "submit" } },
                  [
                    _c("i", { staticClass: "checkmark icon" }),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("globals.buttons.save_changes")) +
                        "\n        "
                    )
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "semantic-modal",
        {
          staticClass: "small",
          attrs: {
            settings: {
              content_classes: { content: true },
              closeable: true,
              closeable_button: false
            }
          },
          model: {
            value: _vm.showChangeEmailModal,
            callback: function($$v) {
              _vm.showChangeEmailModal = $$v
            },
            expression: "showChangeEmailModal"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "ui header",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(_vm.$t("modals.changeemail.header")) +
                  "\n\t\t\t"
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "ui form",
              class: { loading: _vm.forms.changeemail.loader },
              attrs: { "data-vv-scope": "change_email" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.validateEmailChange.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "field",
                  class: { error: _vm.errors.has("change_email.email") }
                },
                [
                  _c(
                    "label",
                    {
                      attrs: { for: "$t('modals.changeemail.form.new_email')" }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("modals.changeemail.form.new_email"))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui left icon input" }, [
                    _c("i", { staticClass: "user icon" }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.forms.changeemail.email,
                          expression: "forms.changeemail.email"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { required: true, email: true },
                          expression: "{ required: true, email: true }"
                        }
                      ],
                      attrs: {
                        type: "email",
                        "data-vv-as": _vm.$t(
                          "modals.changeemail.form.new_email"
                        ),
                        "data-vv-delay": "500",
                        name: "email"
                      },
                      domProps: { value: _vm.forms.changeemail.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.forms.changeemail,
                            "email",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.errors.has("change_email.email")
                    ? _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v(_vm._s(_vm.errors.first("change_email.email")))
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "field",
                  class: { error: _vm.errors.has("change_email.password") }
                },
                [
                  _c(
                    "label",
                    {
                      attrs: { for: "$t('modals.changeemail.form.password')" }
                    },
                    [_vm._v(_vm._s(_vm.$t("modals.changeemail.form.password")))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui left icon input" }, [
                    _c("i", { staticClass: "lock icon" }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.forms.changeemail.password,
                          expression: "forms.changeemail.password"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:6",
                          expression: "'required|min:6'"
                        }
                      ],
                      attrs: {
                        "data-vv-as": _vm.$t(
                          "modals.changeemail.form.password"
                        ),
                        type: "password",
                        name: "password"
                      },
                      domProps: { value: _vm.forms.changeemail.password },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.forms.changeemail,
                            "password",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.errors.has("change_email.password")
                    ? _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v(
                          _vm._s(_vm.errors.first("change_email.password"))
                        )
                      ])
                    : _vm._e()
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "actions",
              attrs: { slot: "actions" },
              slot: "actions"
            },
            [
              _c("div", { staticClass: "ui negative button" }, [
                _vm._v(_vm._s(_vm.$t("globals.buttons.cancel")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "ui blue button",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.validateEmailChange.apply(null, arguments)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("globals.buttons.update")))]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "semantic-modal",
        {
          staticClass: "small",
          attrs: {
            settings: {
              content_classes: { content: true },
              closeable: true,
              closeable_button: false
            }
          },
          model: {
            value: _vm.showChangePasswordModal,
            callback: function($$v) {
              _vm.showChangePasswordModal = $$v
            },
            expression: "showChangePasswordModal"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "ui header",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(_vm.$t("modals.changepassword.header")) +
                  "\n\t\t\t"
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "ui form",
              class: { loading: _vm.forms.changepassword.loader },
              attrs: { "data-vv-scope": "change_password" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.validatePasswordChange.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "field",
                  class: { error: _vm.errors.has("change_password.password") }
                },
                [
                  _c(
                    "label",
                    {
                      attrs: {
                        for: _vm.$t("modals.changepassword.form.old_password")
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("modals.changepassword.form.old_password")
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui left icon input" }, [
                    _c("i", { staticClass: "lock icon" }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.forms.changepassword.old_password,
                          expression: "forms.changepassword.old_password"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:6",
                          expression: "'required|min:6'"
                        }
                      ],
                      attrs: {
                        type: "password",
                        "data-vv-delay": "500",
                        "data-vv-as": _vm.$t(
                          "modals.changepassword.form.old_password"
                        ),
                        name: "password"
                      },
                      domProps: {
                        value: _vm.forms.changepassword.old_password
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.forms.changepassword,
                            "old_password",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.errors.has("change_password.password")
                    ? _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v(
                          _vm._s(_vm.errors.first("change_password.password"))
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "field",
                  class: {
                    error: _vm.errors.has("change_password.new_password")
                  }
                },
                [
                  _c(
                    "label",
                    {
                      attrs: {
                        for: _vm.$t("modals.changepassword.form.new_password")
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("modals.changepassword.form.new_password")
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui left icon input" }, [
                    _c("i", { staticClass: "lock icon" }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.forms.changepassword.new_password,
                          expression: "forms.changepassword.new_password"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:6",
                          expression: "'required|min:6'"
                        }
                      ],
                      attrs: {
                        type: "password",
                        "data-vv-as": _vm.$t(
                          "modals.changepassword.form.new_password"
                        ),
                        name: "new_password"
                      },
                      domProps: {
                        value: _vm.forms.changepassword.new_password
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.forms.changepassword,
                            "new_password",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("change_password.new_password"),
                          expression:
                            "errors.has('change_password.new_password')"
                        }
                      ],
                      staticStyle: { color: "red" }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.errors.first("change_password.new_password"))
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "field",
                  class: {
                    error: _vm.errors.has("change_password.confirm_password")
                  }
                },
                [
                  _c(
                    "label",
                    {
                      attrs: {
                        for: _vm.$t(
                          "modals.changepassword.form.confirm_password"
                        )
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("modals.changepassword.form.confirm_password")
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui left icon input" }, [
                    _c("i", { staticClass: "lock icon" }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.forms.changepassword.confirm_password,
                          expression: "forms.changepassword.confirm_password"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:6",
                          expression: "'required|min:6'"
                        }
                      ],
                      attrs: {
                        type: "password",
                        "data-vv-as": _vm.$t(
                          "modals.changepassword.form.confirm_password"
                        ),
                        name: "confirm_password"
                      },
                      domProps: {
                        value: _vm.forms.changepassword.confirm_password
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.forms.changepassword,
                            "confirm_password",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.errors.has("change_password.confirm_password")
                    ? _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first("change_password.confirm_password")
                          )
                        )
                      ])
                    : _vm._e()
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "actions",
              attrs: { slot: "actions" },
              slot: "actions"
            },
            [
              _c("div", { staticClass: "ui negative button" }, [
                _vm._v(_vm._s(_vm.$t("globals.buttons.cancel")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "ui blue button",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.validatePasswordChange.apply(null, arguments)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("globals.buttons.update")))]
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui divider horizontal header" }, [
      _c("i", { staticClass: "address card icon" }),
      _vm._v("\n        Social Number Settings\n      ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui corner label" }, [
      _c("i", { staticClass: "asterisk icon" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42ba49bb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42ba49bb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/profile/ProfileSettings.vue
// module id = U7gJ
// module chunks = 1